import React from 'react';

import { ProductBrowserCustomFilters as ProductBrowser } from '@techstyle/react-components';

import ProductListingFilter from '../ProductListingFilter';
import ProductSizeFilter from '../ProductSizeFilter';

function ProductFilters(props) {
  return (
    <ProductBrowser.ProductFilters
      combineFilterSizeData
      hideCategoryFilter
      listingFilterComponent={ProductListingFilter}
      sizeFilterComponent={ProductSizeFilter}
      {...props}
    />
  );
}

export default ProductFilters;
